var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebFeature1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_169_4811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1247 36.8425C35.3176 36.8425 38.2057 35.5488 40.2975 33.4569C42.3894 31.365 43.6831 28.4765 43.6831 25.2841C43.6831 22.0916 42.3894 19.203 40.2975 17.1112C38.2057 15.0194 35.3157 13.7256 32.1247 13.7256C28.9318 13.7256 26.0436 15.0193 23.9518 17.1112C21.86 19.2031 20.5663 22.0916 20.5663 25.2841C20.5663 28.4765 21.8599 31.3651 23.9518 33.4569C26.0437 35.5488 28.9336 36.8425 32.1247 36.8425ZM16.8082 33.2789C17.4045 33.2789 17.8872 33.7615 17.8872 34.3579C17.8872 34.9524 17.4046 35.4369 16.8082 35.4369H3.5981C3.00174 35.4369 2.51911 34.9543 2.51911 34.3579C2.51911 33.7634 3.00169 33.2789 3.5981 33.2789H16.8082ZM14.1254 26.0418C14.7218 26.0418 15.2044 26.5244 15.2044 27.1208C15.2044 27.7153 14.7218 28.1998 14.1254 28.1998H0.915354C0.318995 28.1998 -0.163635 27.7172 -0.163635 27.1208C-0.163635 26.5244 0.318948 26.0418 0.915354 26.0418H14.1254ZM11.6042 18.8047C12.1987 18.8047 12.6831 19.2873 12.6831 19.8837C12.6831 20.4782 12.2006 20.9627 11.6042 20.9627H3.59617C2.99981 20.9627 2.51718 20.4801 2.51718 19.8837C2.51718 19.2892 2.99977 18.8047 3.59617 18.8047H11.6042ZM19.4872 11.5676C20.0817 11.5676 20.5662 12.0502 20.5662 12.6466C20.5662 13.2411 20.0836 13.7256 19.4872 13.7256H6.27709C5.68073 13.7256 5.1981 13.243 5.1981 12.6466C5.1981 12.0502 5.68068 11.5676 6.27709 11.5676H19.4872ZM28.8513 9.3069C28.255 9.3069 27.7724 8.82432 27.7724 8.22791C27.7724 7.63339 28.2549 7.14893 28.8513 7.14893H35.3951C35.9896 7.14893 36.4741 7.63151 36.4741 8.22791C36.4741 8.82432 35.9915 9.3069 35.3951 9.3069H33.2004V11.608C36.5566 11.8685 39.575 13.3384 41.8195 15.5826C44.3004 18.0634 45.8364 21.4931 45.8364 25.2807C45.8364 29.0684 44.3023 32.4957 41.8195 34.9789C39.3387 37.4598 35.909 38.9957 32.1214 38.9957C28.3337 38.9957 24.9064 37.4617 22.4232 34.9789C19.9423 32.498 18.4064 29.0684 18.4064 25.2807C18.4064 21.4931 19.9404 18.0657 22.4232 15.5826C24.6674 13.3384 27.6859 11.8685 31.0423 11.608V9.3069H28.8477H28.8513ZM31.046 18.4122C31.046 17.8177 31.5286 17.3332 32.125 17.3332C32.7195 17.3332 33.204 17.8158 33.204 18.4122V23.4199L35.951 21.8326C36.4648 21.5372 37.1199 21.7152 37.4172 22.229C37.7126 22.7428 37.5346 23.3979 37.0208 23.6951L32.7508 26.1595C32.5746 26.2843 32.3581 26.3577 32.1269 26.3577C31.5324 26.3577 31.0479 25.8751 31.0479 25.2787V18.4104L31.046 18.4122ZM24.0583 25.2806C24.0583 24.6861 24.5409 24.2016 25.1373 24.2016C25.7319 24.2016 26.2163 24.6842 26.2163 25.2806C26.2163 26.9119 26.8769 28.3891 27.9467 29.4589C29.0165 30.5286 30.4937 31.1893 32.125 31.1893C32.7195 31.1893 33.204 31.6718 33.204 32.2682C33.204 32.8628 32.7214 33.3472 32.125 33.3472C29.8991 33.3472 27.8825 32.4444 26.4217 30.9856C24.9628 29.5268 24.06 27.5083 24.06 25.2842L24.0583 25.2806Z",
    fill: "url(#paint0_linear_169_4811)",
    stroke: "url(#paint1_linear_169_4811)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_169_4811",
    x1: -12.2493,
    y1: 198.396,
    x2: 123.739,
    y2: 89.4088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_169_4811",
    x1: -12.2493,
    y1: 198.396,
    x2: 123.739,
    y2: 89.4088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_169_4811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white",
    transform: "translate(0.0360718 0.536133)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebFeature1);
export default __webpack_public_path__ + "static/media/web_feature_1.8aee7ea719fab282729ddd5fb546b384.svg";
export { ForwardRef as ReactComponent };